import * as APIUtil from "../util/courseSections_api_util";

// Action Types
export const RECEIVE_COURSE_SECTIONS = "RECEIVE_COURSE_SECTIONS";
export const RECEIVE_COURSE_SECTION = "RECEIVE_COURSE_SECTION";
export const REMOVE_COURSE_SECTION = "REMOVE_COURSE_SECTION";

// Action Creators
const receiveCourseSections = (sections) => ({
  type: RECEIVE_COURSE_SECTIONS,
  sections,
});

const receiveCourseSection = (section) => ({
  type: RECEIVE_COURSE_SECTION,
  section,
});

const removeCourseSection = (sectionId) => ({
  type: REMOVE_COURSE_SECTION,
  sectionId,
});

// Thunks

// Fetch all sections for a specific course
export const fetchCourseSections = (courseId) => async (dispatch) => {
  try {
    const response = await APIUtil.fetchCourseSections(courseId);
    dispatch(receiveCourseSections(response.data));
  } catch (error) {
    console.error("Error fetching course sections:", error);
  }
};

// Create a new course section
export const createCourseSection = (data) => async (dispatch) => {
  try {
    const response = await APIUtil.createCourseSection(data);
    dispatch(receiveCourseSection(response.data));
  } catch (error) {
    console.error("Error creating course section:", error);
  }
};

// Update a course section
export const updateCourseSection = (id, updates) => async (dispatch) => {
  try {
    const response = await APIUtil.updateCourseSection(id, updates);
    dispatch(receiveCourseSection(response.data));
  } catch (error) {
    console.error("Error updating course section:", error);
  }
};

// Delete a course section
export const deleteCourseSection = (id) => async (dispatch) => {
  try {
    await APIUtil.deleteCourseSection(id);
    dispatch(removeCourseSection(id));
  } catch (error) {
    console.error("Error deleting course section:", error);
  }
};
